const createAdSlice = (set, get, ref) => {

  ref.ad = {
    methods: {
      fetchAd: () => {
        const socket = get().socket;
        const telegramUserId = ref.telegram.telegramUserId;
        const { adData, setAdData } = get();

        // Если сокет не готов или реклама уже есть — выходим
        if (!socket || !socket.connected) return;
        if (adData) return;

        // Определяем локаль:
        // 1. Из настроек игры (приоритет)
        // 2. Из настроек телеграма
        // 3. Дефолтная 'en'
        const locale = ref.info.game?.locale || ref.telegram.languageCode || 'ru';

        console.log(`📢 Preloading Canvas Ad for locale: ${locale}...`);

        socket.emit('getAd', {
          userId: telegramUserId,
          locale: locale
        }, (response) => {
          if (response && response.success && response.ad) {

            // Обрабатываем картинку (Buffer -> Blob URL)
            if (response.ad.image) {
              try {
                const uint8Array = new Uint8Array(response.ad.image);
                // Картинка приходит в формате JPEG (обычно фото в ТГ это jpg)
                // Если вы загружаете png, можно поменять type, но браузер часто распознает blob корректно
                const blob = new Blob([uint8Array], { type: 'image/jpeg' });
                response.ad.imageUrl = URL.createObjectURL(blob);
                // Удаляем сырой буфер из памяти
                delete response.ad.image;
              } catch (e) {
                console.error('Ad image processing error', e);
              }
            }

            // Сохраняем готовую рекламу в стор
            setAdData(response.ad);
            console.log('📢 Canvas Ad preloaded successfully');
          }
        });
      }
    }
  };

  return {
    adData: null, // Хранит объект { id, text, imageUrl, button }
    setAdData: (data) => set({ adData: data }),
    clearAdData: () => set({ adData: null }),
  };
};

export default createAdSlice;
